// extracted by mini-css-extract-plugin
module.exports = {"login-background":"ResetPasswordConfirmation_login-background__1vaSS","card":"ResetPasswordConfirmation_card__t87gY"};